export default __webpack_public_path__ + "static/media/667.b2199841.gif";